module.exports = __webpack_public_path__ + "img/电力储能2.837f4392.jpg";